import { RoleTypes } from "./roleTypes";

export const categories = [
  { value: RoleTypes.Farmer.value, label: RoleTypes.Farmer.label },
  { value: RoleTypes.Citizen.value, label: RoleTypes.Citizen.label },
];
